module.exports = require("babel-core/register");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/register.js
 ** module id = 521
 ** module chunks = 0
 **/